import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import {
  HeaderPage,
  TableOffersAdmin,
  AddEditOfferForm,
} from "../../components/Admin";
import { ModalBasic, ModalConfirm } from "../../components/Common";
import { useOffer } from "../../hooks";

export function OffersAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const { loading, offers, getOffers, deleteOffer } = useOffer();

  useEffect(() => {
    getOffers();
  }, [refetch]);

  const openCloseModal = () => setShowModal((prev) => !prev);
  const onRefetch = () => setRefetch((prev) => !prev);

  const addOffer = () => {
    setTitleModal("Nueva oferta");
    setContentModal(
      <AddEditOfferForm onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updateOffer = (data) => {
    setTitleModal("Editar oferta");
    setContentModal(
      <AddEditOfferForm
        onClose={openCloseModal}
        onRefetch={onRefetch}
        offer={data}
      />
    );
    openCloseModal();
  };

  const onDeleteOffer = (data) => setDeleteTarget(data);

  const confirmDeleteOffer = async () => {
    await deleteOffer(deleteTarget.id);
    setDeleteTarget(null);
    onRefetch();
  };

  return (
    <>
      <HeaderPage title="Ofertas" btnTitle="Nueva oferta" btnClick={addOffer} />

      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <TableOffersAdmin
          offers={offers}
          updateOffer={updateOffer}
          deleteOffer={onDeleteOffer}
        />
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

      <ModalConfirm
        title="¿Eliminar oferta?"
        content={`Se eliminará "${deleteTarget?.title}" de forma permanente.`}
        show={!!deleteTarget}
        onCloseText="Cancelar"
        onClose={() => setDeleteTarget(null)}
        onConfirmText="Eliminar"
        onConfirm={confirmDeleteOffer}
      />
    </>
  );
}
